<script>

import bem from '@/utils/bem';
import { mapActions, mapState } from 'vuex';
import HelpCenters from '@/components/helpCenters/Help-centers.vue';

const b = bem('faq-template-tab');

export default {
  components: { HelpCenters },
  data() {
    return {

    };
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
  },
  ...mapActions({
    getTemplatesHelpCenter: 'helpCenter/getTemplatesHelpCenter',
    createTemplateHelpCenter: 'helpCenter/createTemplateHelpCenter',
    editTemplateHelpCenter: 'helpCenter/editTempateHelpCenter',
    deleteTemplateHelpCenter: 'helpCenter/deleteTemplateHelpCenter',
  }),
  computed: {
    ...mapState({
      helpCenterTemplates: (state) => state.helpCenter.helpCenterTemplates,
      isLoadingTemplates: (state) => state.helpCenter.isLoadingTemplates,
    }),
  },
};
</script>

<template>
  <help-centers
    :helpCenters="(helpCenterTemplates || [])"
    :create-hint="((value)=>console.log(value))"
    :edit-hint="(value) => editTemplateHelpCenter(value)"
    :delete-hint="deleteTemplateHelpCenter"
    without-category
  />
</template>

<style lang="scss" scoped>

</style>
